<template>
    <div class="columns has-text-centered justify-center">
        <div class="column">
            <pie-chart :chart-data="pieChartData" />
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            pieChartData: {
                type: Object,
                // eslint-disable-next-line vue/require-valid-default-prop
                default: {}
            }
        },
        data() {
            return {
            }
        },
        created() {




            // console.log(this.pieChartData)

            // setInterval(async () =>
            // {
            //     // LastId başlangıçta 0 olacak şekilde parametre gönderilecek.
            //     // Gelen notify listesinin ilk elemanı eklenmiş lastid olarak kayda alınacaktır.
            //     // Gelen notify listesinin balonlara doldurulmasıdır.
            //
            //     // burada login olmadan öncede çalışabilmektedir. login varsa çalıştırsın...
            //     this.$forceUpdate();
            //     this.renderChart({
            //         datasets: [
            //             {
            //                 backgroundColor: this.chartData.backgroundColor,
            //                 data: this.chartData.data
            //             }
            //         ],
            //     }, {responsive: true, maintainAspectRatio: false,events:false})
            //     alert("rendered")
            //     // this.GetNotifies(this.LastId);
            //     console.log(this.pieChartData)
            // }, 1000); //25000


        },
        methods: {

            /*
            methodThatForcesUpdate()
            {
                // ...

                this.$forceUpdate();  // Notice we have to use a $ here
                // ...
            } */
        },


    }
    import Vue from "vue";
    import VueChartJs from "vue-chartjs";

    Vue.component('pie-chart', {
        extends: VueChartJs.Pie,
        props: {
            chartData: Object
        },

        mounted () {
            console.log("chartData !!!!!!!!!")
            console.log(this.chartData)
            if(this.chartData.backgroundColor !== undefined)
            {
                this.renderChart({
                    datasets: [
                        {
                            backgroundColor: this.chartData.backgroundColor,
                            data: this.chartData.data
                        }
                    ],
                }, {responsive: true, maintainAspectRatio: false,events:false})
            }
            // this.renderChart({
            //     datasets: [
            //         {
            //             backgroundColor: this.chartData.backgroundColor,
            //             data: this.chartData.data
            //         }
            //     ],
            // }, {responsive: true, maintainAspectRatio: false,events:false})
        }

    })

</script>
